import ModuleLayout from "../../components/enterprise/ModuleLayout";
import { systemTabsForRole } from "../navigation";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import AlertVisualSettings from "../../components/alerts/AlertVisualSettings";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";

const SystemModulePage = ({ title, subtitle, children, role, dataMode = { mode: "real" } }) => {
  const { t } = useTranslation();
  const location = useLocation();
  return (
    <ModuleLayout title={title} subtitle={subtitle} breadcrumbs={[t("platform.nav.system"), title]} tabs={systemTabsForRole(role)} dataMode={dataMode}>
      {location.pathname === "/system/notifications" && <AlertVisualSettings />}
      {location.pathname === "/system/health" && <Button component={Link} to="/monitoring/health" size="small" sx={{ mb: 2 }}>{t("platform.pages.cameraHealth.title")}</Button>}
      {children}
    </ModuleLayout>
  );
};

export default SystemModulePage;
